import React, { useEffect, useState } from 'react';
import { Card } from '../ui/card';
import { ShieldCheck, ShieldAlert, ShieldX, Loader2 } from 'lucide-react';
import api from '../../lib/api';

const ROW = (label, present) => ({ label, present });

// Dashboard insight — sending-domain auth health (SPF / DKIM / DMARC).
export const DeliverabilityCard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/deliverability/domain-auth')
      .then((res) => setData(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Card className="p-5" data-testid="deliverability-card">
        <div className="flex items-center gap-2 text-muted-foreground text-sm"><Loader2 className="h-4 w-4 animate-spin" /> Checking domain auth…</div>
      </Card>
    );
  }
  if (!data || data.error) return null;

  const rows = [
    ROW('SPF', data.spf?.present),
    ROW('DKIM', data.dkim?.present),
    ROW('DMARC', data.dmarc?.present),
  ];
  const Icon = data.status === 'pass' ? ShieldCheck : data.status === 'partial' ? ShieldAlert : ShieldX;
  const tone = data.status === 'pass' ? 'text-emerald-400' : data.status === 'partial' ? 'text-amber-400' : 'text-red-400';

  return (
    <Card className="p-5" data-testid="deliverability-card">
      <div className="flex items-center gap-2 mb-3">
        <Icon className={`h-4 w-4 ${tone}`} />
        <h3 className="text-sm font-semibold text-foreground">Deliverability</h3>
        <span className="text-xs text-muted-foreground truncate">· {data.domain}</span>
      </div>
      <div className="flex gap-2">
        {rows.map((r) => (
          <div key={r.label} data-testid={`deliverability-${r.label.toLowerCase()}`}
            className={`flex-1 rounded-lg border px-3 py-2 text-center ${r.present ? 'border-emerald-500/30 bg-emerald-500/[0.06]' : 'border-red-500/25 bg-red-500/[0.04]'}`}>
            <p className="text-xs font-medium text-foreground">{r.label}</p>
            <p className={`text-[11px] mt-0.5 ${r.present ? 'text-emerald-400' : 'text-red-400'}`}>{r.present ? 'OK' : 'Missing'}</p>
          </div>
        ))}
      </div>
      {data.status !== 'pass' && (
        <p className="text-[11px] text-muted-foreground mt-3">
          Add the missing DNS records to your sending domain to protect inbox placement and sender reputation.
        </p>
      )}
    </Card>
  );
};

export default DeliverabilityCard;
